import {
  querySecondNavs
} from '@/axios/com'

import {
  queryIdleAds,
  queryIdleTab,
  queryIdleAttrs,
  queryIdleList,
  queryIdleDetail
} from '@/axios/idle'

const idleData = {
  state: {
    banners: [],
    rightBanners: [],
    secondNavs: [],
    attrs: [],
    tab: [],
    rows: [],
    total: 0,
    detail: {},
    userTypes: [
      { title: '企业', value: 'qiye' },
      { title: '个人', value: 'geren' },
      { title: '中介', value: 'zhongjie' },
      { title: '组织', value: 'zuzhi' }
    ]
  },
  mutations: {
    SET_IDLE_ADS (state, data) {
      state.banners = data.banners
      state.rightBanners = data.right
    },
    SET_IDLE_TAB (state, data) {
      state.tab = data
    },
    SET_IDLE_NAVS (state, data) {
      state.secondNavs = data
    },
    SET_IDLE_ATTRS (state, data) {
      state.attrs = data
    },
    SET_IDLE_LIST (state, data) {
      state.rows = data.rows
      state.total = data.count
    },
    SET_IDLE_DETAIL (state, data) {
      state.detail = data
    }
  },
  actions: {
    async IDLE_ADS ({ commit }, params) {
      const res = await queryIdleAds(params)
      commit('SET_IDLE_ADS', res.data.data)
    },
    async IDLE_NAVS ({ commit }, params) {
      const res = await querySecondNavs(params)
      commit('SET_IDLE_NAVS', res.data.data)
    },
    async IDLE_TAB ({ commit }, params) {
      const res = await queryIdleTab(params)
      commit('SET_IDLE_TAB', res.data.data)
    },
    async IDLE_ATTRS ({ commit }, params) {
      const res = await queryIdleAttrs(params)
      commit('SET_IDLE_ATTRS', res.data.data)
    },
    async IDLE_LIST ({ commit }, params) {
      const res = await queryIdleList(params)
      commit('SET_IDLE_LIST', res.data.data)
    },
    async IDLE_DETAIL ({ commit }, params) {
      const res = await queryIdleDetail(params)
      commit('SET_IDLE_DETAIL', res.data.data)
    }
  }
}

export default idleData



// WEBPACK FOOTER //
// ./src/store/modules/idleData.js